/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";

interface Props {
  labelName?: string;
  setInputText: Function;
  options?: any;
  defaultValue?: any;
  value?: any;
  disabled?: boolean;
}

function DropdownWithClear({
  labelName,
  setInputText,
  options,
  value,
  defaultValue,
  disabled,
}: Props) {
  const onHandleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (e.target.value) {
      setInputText(JSON.parse(e.target.value));
    }
  };
  const [name, setName] = React.useState<any>();

  useEffect(() => {
    if (!value || Object.keys(value).length === 0) {
      setName(labelName);
    } else if (value?._id === defaultValue) {
      setName(value?.name);
    }
  }, [value, defaultValue, labelName]);

  const onChangeClear = () => {
    setInputText({});
    setName(labelName);
  };
  return (
    <div className="d-flex mb-2 CustomDropDown">
      <select
        className="w-100 p-2 form-select"
        defaultValue={name}
        value={JSON.stringify(value)}
        onChange={(e) => {
          onHandleChange(e);
        }}
        disabled={disabled}
      >
        <option value="">{labelName}</option>
        {options?.length > 0
          ? options?.map((item: any) => {
            return (
              <option key={item?._id} value={JSON.stringify(item)}>
                {item?.percentage ? item?.percentage : item?.name}
              </option>
            );
          })
          : null}
      </select>
      <button
        type="button"
        className="ms-1 rounded border"
        onClick={onChangeClear}
        disabled={disabled}
      >
        <span className="d-flex align-items-center">
          <DeleteIcon
            className="cursor "
            fontSize="small"
            color={value ? "error" : undefined}
          />
        </span>
      </button>
    </div>
  );
}

export default React.memo(DropdownWithClear);
